import React from 'react';
import Dots from '../../../atoms/Dots/Dots';
import ANJALIBODEPIC from '../../../../app/assets/images/anjaliBodepic.webp';

type FounderSectionProps = {
  founderSection?: {
    label?: string;
    heading?: string;
    subHeading?: string;
    badgeName?: string;
    badgeRole?: string;
    paragraphs?: string[];
    quote?: string;
  };
};

const FounderSection = ({ founderSection }: FounderSectionProps) => {
  const {
    label,
    heading,
    subHeading,
    badgeName,
    badgeRole,
    paragraphs = [],
    quote,
  } = founderSection ?? {};

  if (!founderSection) return null;

  return (
    <div className="mt-10 md:mt-16 text-white">
      <div className="max-w-[2400px] mx-auto">

      {/* 🔹 TOP CONTENT */}
      <div className="flex flex-col items-center text-center">
        {label && (
          <div className="text-[10px] md:text-sm uppercase tracking-[0.35em] text-[#2A8BFD] mb-3 3xl:text-xl 3xl:mb-5">
            {label}
          </div>
        )}

        {heading && (
          <div className="text-[clamp(1.7rem,5vw,3rem)] md:text-[44px] lg:text-5xl xl:text-[56px] 2xl:text-[64px] 3xl:text-[80px] font-semibold tracking-wide">
            {heading}
          </div>
        )}

        {subHeading && (
          <div className="mt-2 max-w-[28ch] text-[clamp(0.82rem,2.3vw,1.125rem)] font-light text-white/70 sm:mt-3 md:max-w-2xl md:text-lg xl:text-xl xl:max-w-3xl 2xl:text-2xl 2xl:max-w-4xl 3xl:text-3xl 3xl:max-w-5xl 3xl:mt-8">
            <span className="md:hidden">{subHeading}</span>
            <span className="hidden md:inline">{subHeading}</span>
          </div>
        )}

        <Dots width="w-5 md:w-7" height="h-5 md:h-7" className="mt-4 md:mt-5" />
      </div>

      {/* 🔹 MAIN SECTION */}
<div className="mt-12 flex flex-col items-center justify-center gap-8 md:mt-20 lg:flex-row lg:items-start lg:gap-20 xl:gap-28 2xl:gap-36 3xl:gap-48 px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 3xl:px-48">

    {/* 🟦 LEFT IMAGE */}
    <div className="flex w-full justify-center lg:w-[40%] lg:justify-end">
        <div className="relative h-[300px] w-[220px] sm:h-[360px] sm:w-[260px] md:h-[470px] md:w-[360px] lg:h-[520px] lg:w-[400px] xl:h-[560px] xl:w-[440px] 2xl:h-[640px] 2xl:w-[500px] 3xl:h-[820px] 3xl:w-[640px]">

            {/* Image */}
            <div className="absolute inset-0 rounded-t-full z-10">
                <div className="absolute inset-0 rounded-t-full bg-[linear-gradient(135deg,transparent_0%,transparent_22%,rgba(34,156,255,0.25)_60%,rgba(34,156,255,1)_100%)] p-[4px] sm:p-[6px] md:p-[8px]">
                    <div className="w-full h-full rounded-t-full overflow-hidden bg-[#141414]">
                        <img
                            src={ANJALIBODEPIC}
                            alt={badgeName ? `${badgeName} portrait` : 'Founder portrait'}
                            className="w-full h-full object-cover object-[center_top] scale-[1.05] origin-top"
                        />
                    </div>
                </div>
            </div>

            {/* Badge */}
            {(badgeName || badgeRole) && (
                <div className="absolute bottom-5 right-0 bg-black/75 px-4 py-2.5 backdrop-blur-[2px] z-20 sm:px-5 sm:py-3 md:bottom-8 md:px-8 md:py-5">
                    {badgeName && (
                        <div className="text-[#2A8BFD] font-medium text-[13px] sm:text-[14px] md:text-[18px]">
                            {badgeName}
                        </div>
                    )}
                    {badgeRole && (
                        <div className="text-white text-[10px] sm:text-[11px] md:text-[14px]">
                            {badgeRole}
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>

    {/* 🟩 RIGHT CONTENT */}
    <div className="w-full max-w-[42rem] text-center lg:text-left lg:w-[50%] lg:max-w-none lg:px-0 lg:pt-10 xl:w-[55%]">
        <div className="space-y-5 text-[15px] leading-7 text-white/90 font-light sm:space-y-6 sm:text-[16px] md:space-y-6 md:text-[17px] md:leading-[1.85] xl:text-[18px] xl:leading-[1.9] 2xl:text-[20px] 2xl:leading-[2] 3xl:text-[26px] 3xl:leading-[2] 3xl:space-y-8">
            {paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph.replace(/\s+/g, ' ').trim()}</p>
            ))}
        </div>

        {quote && (
            <p className="mt-6 w-full text-[15px] font-normal leading-7 text-[#2A8BFD] sm:text-[16px] md:mt-8 md:text-[17px] md:leading-[1.8] xl:text-[19px] 2xl:text-[22px] 3xl:text-[28px] 3xl:mt-12">
                &ldquo;{quote.replace(/\s+/g, ' ').trim()}&rdquo;
            </p>
        )}
    </div>
</div>
      </div>
    </div>
  );
};

export default FounderSection;
